import type {
	ParagonIntegration,
	ParagonIntegrationWithUpsalesMeta,
	AuthenticatedConnectUser,
	AuthenticatedConnectUserWithMeta,
	ParagonConnectionMetadata
} from './paragonTypes';

const isMultiAccountIntegration = (integrationName: string) => {
	// TODO: We are going to implement setting integrations as multiAccount/user only in master or in Paragon in later ticket.
	const isSAP = !!integrationName.match(/SAP/gm);
	return isSAP;
};

export const combineUserWithIntegration = (
	integration: ParagonIntegration | ParagonIntegrationWithUpsalesMeta,
	user: AuthenticatedConnectUser | null
): ParagonIntegrationWithUpsalesMeta => {
	const typedUser = user ? (user as AuthenticatedConnectUserWithMeta) : null;
	const isConnected = user?.integrations?.[integration.type]?.enabled ?? false;
	const configurations = user?.integrations?.[integration.type]?.allCredentials;
	const multiAccount = isMultiAccountIntegration(integration.name);

	const configurationsWithMeta = configurations?.map(configuration => {
		const configMeta = (typedUser?.meta?.[integration.type]?.[configuration.id] as ParagonConnectionMetadata) ?? {};
		return {
			...configuration,
			...configMeta
		};
	});

	const collator = new Intl.Collator(undefined, {
		numeric: true, // 2 < 10
		sensitivity: 'base' // "Con" = "con"
	});

	const sortedConfigurationsByNameAndDate = configurationsWithMeta?.sort((a, b) => {
		if (a.name && b.name) {
			const byName = collator.compare(a.name, b.name);
			if (byName !== 0) {
				return byName;
			}
		}
		if (a.dateCreated && b.dateCreated) {
			return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime();
		}
		return 0;
	});

	return {
		...integration,
		isConnected,
		multiAccount,
		configurations: sortedConfigurationsByNameAndDate ?? []
	};
};
